import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ApiService from '../services/ApiService';

export default class DashboardProfileHeader extends Component {
    constructor() {
        super();
        this.apiService = ApiService.getInstance();
    }

    render() {
        const that = this;

        return (
            <div className="dashboard__top-bar">
                <div>
                    <h3 className="h3">Profil użytkownika</h3>
                    <span id="dashboard-login">{localStorage.getItem('login')}</span>
                </div>
                <Link to="/">
                    <button
                        className="profile__logout"
                        onClick={() => {
                            that.logout();
                        }}
                    >
                        Wyloguj się
                    </button>
                </Link>
            </div>
        );
    }

    logout() {
        this.apiService.logout();
    }
}
